import React, { Component } from 'react';
import { Table, Select } from 'antd';
import Header from '../Common/Component/Header';
import Sidebar from '../Common/Component/Sidebar';

import userimg from '../../Assets/images/userimg.jpg';

const { Option } = Select;
const columns = [
  {
    title: 'ID & Name',
    dataIndex: 'name',
    // specify the condition of filtering result
    // here is that finding the name started with `value`
    onFilter: (value, record) => record.name.indexOf(value) === 0,
    sorter: (a, b) => a.name.length - b.name.length,
    sortDirections: ['descend'],
  },
  {
    title: 'Owner',
    dataIndex: 'owner',
    defaultSortOrder: 'descend',
    sorter: (a, b) => a.age - b.age,
  },
  {
    title: 'Address',
    dataIndex: 'address',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Users',
    dataIndex: 'users',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Customers',
    dataIndex: 'customers',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Monthly Revenue',
    dataIndex: 'monthlyevenue',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Yearly Revenue',
    dataIndex: 'yearlyrevenue',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'All Time Revenue',
    dataIndex: 'alltimetevenue',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Satisfaction',
    dataIndex: 'satisfaction',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: 'Year Started',
    dataIndex: 'yearstarted',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  },
  {
    title: '',
    dataIndex: 'actionmenu',
    filterMultiple: false,
    onFilter: (value, record) => record.address.indexOf(value) === 0,
    sorter: (a, b) => a.address.length - b.address.length,
    sortDirections: ['descend', 'ascend'],
  }
];

const data = [
  {
    name: '001 Middlesex, NJ',
    owner: 'John Brown',
    address: '701 Valley Dr, Saint Louis, MO 63137',
    users: '32',
    customers: '32',
    monthlyevenue: '$80.8k',
    yearlyevenue: '$964.8k',
    alltimetevenue: '$964.8k',
    satisfaction: '98%',
    yearstarted: '2018',
    actionmenu: '...',
  },
  {
    name: '001 Middlesex, NJ',
    owner: 'John Brown',
    address: '701 Valley Dr, Saint Louis, MO 63137',
    users: '32',
    customers: '32',
    monthlyevenue: '$80.8k',
    yearlyevenue: '$964.8k',
    alltimetevenue: '$964.8k',
    satisfaction: '98%',
    yearstarted: '2018',
    actionmenu: '...',
  },
  {
    name: '001 Middlesex, NJ',
    owner: 'John Brown',
    address: '701 Valley Dr, Saint Louis, MO 63137',
    users: '32',
    customers: '32',
    monthlyevenue: '$80.8k',
    yearlyevenue: '$964.8k',
    alltimetevenue: '$964.8k',
    satisfaction: '98%',
    yearstarted: '2018',
    actionmenu: '...',
  },
  {
    name: '001 Middlesex, NJ',
    owner: 'John Brown',
    address: '701 Valley Dr, Saint Louis, MO 63137',
    users: '32',
    customers: '32',
    monthlyevenue: '$80.8k',
    yearlyevenue: '$964.8k',
    alltimetevenue: '$964.8k',
    satisfaction: '98%',
    yearstarted: '2018',
    actionmenu: '...',
  },
];



class Typo extends Component {
  onChange = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  }
  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
        
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <Sidebar />

          {/* Page Content */}
          <div className="block-row">
            <div className="container">
              <div className="card mt-30">
                <div className="card-title">
                  <h1>Heading</h1>
                </div>
                <div className="card-body">                 
                  <h1>H1 size 32 with <small>Small title with header</small></h1>
                  <h2>H2 size 20 with <small>Small title with header</small></h2>
                  <h3>H3 size 18 with <small>Small title with header</small></h3>
                  <h4>H4 size 16 with <small>Small title with header</small></h4>
                  <h5>H5 size 15 with <small>Small title with header</small></h5>
                  <h6>H6 size 14 with <small>Small title with header</small></h6>
                </div> 
                <div className="card">
                  <div className="card-body">
                    <button className="btn btn-primary">Basic</button>
                    <button className="btn btn-primary">Primary</button>
                    <button className="btn btn-success">Success</button>
                    <button className="btn btn-warning">Warning</button>
                    <button className="btn btn-danger">Danger</button>
                    <button className="btn disabled">Disabled</button>
                    <a href="http://dev.doodycalls.com/" target="_blank" rel="noopener noreferrer" className="btn btn-txt">Link</a>
                  </div>
                  <div className="card-body">
                    <div className="btn-grp">
                      <button type="button" className="btn btn-bdr">Basic</button>
                      <button type="button" className="btn btn-brand btn-bdr">Primary</button>
                      <button type="button" className="btn btn-success btn-bdr">Success</button>
                      <button type="button" className="btn btn-warning btn-bdr">Warning</button>
                      <button type="button" className="btn btn-danger btn-bdr">Danger</button>
                      {/* <button type="button" className="btn disabled btn-bdr" disabled>disabled</button> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="title-row">
                    <h1>listing</h1>
                    <p>All type of content style here...</p>
                  </div>
                  <div className="inner-block-row">
                    <ul className="check-list">
                      <li><i className="las la-check-circle success"></i>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                      <li><i className="las la-times-circle red"></i>Morbi ac justo dictum, vestibulum orci sit amet, euismod neque.</li>
                      <li><i className="las la-times-circle red"></i>In consectetur est eget pellentesque lobortis.</li>
                      <li><i className="las la-check-circle success"></i>Suspendisse suscipit mauris eu libero varius sollicitudin.</li>
                    </ul>
                    <p>
                      Lorem ipsum dolor sit amet, <strong>consectetur</strong> adipisicing elit. Qui aut, dolore eaque sint
                      tenetur fugit ut quas maiores. Veritatis omnis numquam quasi cumque recusandae fugiat expedita, maxime
                      aspernatur vero id.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui aut, dolore eaque sint
                      tenetur fugit ut quas maiores. Veritatis omnis numquam quasi cumque recusandae fugiat expedita, maxime
                      aspernatur vero id.
                    </p>
                    <blockquote className="horiz">
                      <b>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</b>
                      <p className="mb-0">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quia deserunt iure debitis modi rem tenetur
                        molestias iusto error                        
                      </p>                     
                    </blockquote>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <div className="title-row">
                    <h1>Forms &amp; Controls</h1>
                    <p>All type of Forms inputs style here...</p>
                  </div>
                  <div className="inner-block-row">
                    <div className="form-group">
                      <div className="fitem">
                        <label htmlFor="">Input Empty</label>
                        <input type="text" placeholder="Input Empty" />
                      </div>
                      <div className="fitem">
                        <label htmlFor="">Input Disabled</label>
                        <input type="text" disabled="true" value="test" />
                        <label className="validate-message">Success Message will be diplayed here...</label>
                      </div>
                      <div className="fitem">
                        <label htmlFor="">Input test</label>
                        <input type="text" value="test" />
                        <label className="validate-message">Success Message..</label>
                      </div>
                      <div className="fitem">
                        <label htmlFor="">Input Error</label>
                        <input type="text" />
                        <label htmlFor="" className="error">Error Message will be diplayed here...</label>
                      </div>
                      <div className="fitem half-fitem">
                        <div className="half-fitem">
                          <label htmlFor="">Password</label>
                          <div className="inline-fitem">
                            <input type="text" placeholder="8+ characters" />
                            <span className="show-pwd"><img src="assets/images/show-pwd-icon.svg" alt="" />Show</span>
                          </div>
                        </div>

                        <div className="fitem  half-fitem">
                          <label>Antd Select</label>
                          <div>
                            <Select
                              defaultValue="1"
                              showArrow

                              showSearch
                              virtual={false}
                              style={{ width: '100%' }}

                            >

                              <Option value="1">1</Option>
                              <Option value="2">2</Option>
                              <Option value="3">3</Option>
                              <Option value="4">4</Option>
                              <Option value="5">5</Option>
                              <Option value="6">6</Option>
                              <Option value="7">7</Option>
                              <Option value="8">8</Option>
                              <Option value="9">9</Option>
                              <Option value="10">10</Option>
                              <Option value="11">11</Option>
                              <Option value="12">12</Option>
                              <Option value="13">13</Option>
                              <Option value="14">14</Option>
                              <Option value="15">15</Option>
                              <Option value="16">16</Option>
                              <Option value="17">17</Option>
                              <Option value="18">18</Option>
                              <Option value="19">19</Option>
                              <Option value="20">20</Option>
                            </Select>
                          </div>
                        </div>
                        <div className="fitem  half-fitem">
                          <label>Selected Empty</label>
                          <select>
                            <option>Select Empty</option>
                            <option>Lorem ipsum dolor,</option>
                            <option>Lorem ipsum </option>
                            <option>Lorem doloroption </option>
                          </select>


                        </div>
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>

                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                      </div>
                      <div className="fitem half-fitem">
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                      </div>
                      <div className="fitem half-fitem">
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                        <div className="fitem half-fitem">
                          <label htmlFor="">Input label</label>
                          <input type="text" />
                        </div>
                      </div>
                      <div className="fitem half-fitem">
                        <div className="fitem half-fitem inline-check-list">
                          <div className="fitem-check">
                            <input type="radio" className="fitem-ck-input" id="radio1" name="test" />
                            <label htmlFor="radio1" className="fitem-ck-txt">This is radio btn</label>
                          </div>
                          <div className="fitem-check">
                            <input type="radio" className="fitem-ck-input" id="radio2" name="test" />
                            <label htmlFor="radio2" className="fitem-ck-txt">This is radio btn</label>
                          </div>
                        </div>
                        <div className="fitem half-fitem inline-check-list">
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="checkbox" name="checkboxs" />
                            <label htmlFor="checkbox" className="fitem-ck-txt">This is checkbox btn</label>
                          </div>
                          <div className="fitem-check">
                            <input type="checkbox" className="fitem-ck-input" id="checkbox1" name="checkboxsa" />
                            <label htmlFor="checkbox1" className="fitem-ck-txt">This is checkbox btn</label>
                          </div>
                        </div>
                      </div>
                      <div className="fitem">
                        <label>Selected Empty</label>
                        {/* <select>
                          <option>Select Empty</option>
                          <option>Lorem ipsum dolor,</option>
                          <option>Lorem ipsum </option>
                          <option>Lorem doloroption </option>
                        </select> */}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-title">
                  <h2>Profiles, Icons</h2>
                </div>
                <div className="card-body flex flex-start ai-center">
                  <div className="profile-wrap">
                    <figure>
                      <img src={userimg} alt="" />
                    </figure>
                  </div>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="profile-wrap md-profile">
                    <figure>
                      <img src={userimg} alt="" />
                    </figure>
                  </div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="profile-wrap user-profile">
                    <figure>
                      <img src={userimg} alt="" />
                    </figure>
                  </div>
                 
                </div>
                <div className="card-body flex flex-start ai-center">
                  <span className="ico-btn"><i className="las la-filter"></i></span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span className="ico-btn"><i className="las la-file-csv"></i></span>
                </div>               
              </div>
            </div>
          </div>
          
          <div className="block-row">
            <div className="flist">
              <div className="card">
                <div className="card-title">
                  <h5>Card Header</h5>
                </div>
                <div className="card-body">
                  <h5>Card Body</h5>                  
                  <div className="form-group">
                    <div className="fitem">
                      <label htmlFor="">Input test</label>
                      <input type="text" value="test" placeholder="from-control" />
                    </div>
                  </div>                    
                </div>
                <div className="card-footer">
                  <button className="btn btn-primary">Primary</button>                  
                  <button className="btn btn-warning">Warning</button>
                </div>
              </div>  
              <div className="card">               
                <div className="card-body">
                  <h5>Card without header</h5>                  
                  <div className="form-group">
                    <div className="fitem">
                      <label htmlFor="">Input test</label>
                      <input type="text" value="test" placeholder="from-control" />
                    </div>
                  </div>                    
                </div>
                <div className="card-footer">
                  <button className="btn btn-primary">Primary</button>                  
                  <button className="btn btn-warning">Warning</button>
                </div>
              </div>  
              <div className="card add-card">
                <span>Create an additional service</span>
                <span>This can be new service, an additional service or a one-time extra service at any address for this customer.</span>
                <button className="btn btn-warning">Add New Service</button>
              </div>          
            </div>
          </div>
          <div className="block-row">
            <div className="card">
              <div className="card-body">
                {/* Drawer code */}                
                {/* <Drawer
                  visible={true}
                  className="drawer-wrapper"
                >
                </Drawer>
                <div className="card-head"><h4>Sidebar Header</h4></div>
                <div className="card-row">
                  <div className="card-full">
                    <div className="form-group">
                      <div className="fitem">
                        <label htmlFor="">Customer Status</label>
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="active"/>
                          <label htmlFor="active" className="fitem-ck-txt">Active</label>
                        </div>
                        <div className="fitem-check">
                          <input type="checkbox" className="fitem-ck-input" id="in_active"/>
                          <label htmlFor="in_active" className="fitem-ck-txt">InActive</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer">
                  <button className="btn btn-primary">Cancel</button>
                  <button className="btn btn-warning">Filter Customer</button>
                </div> */}
                <h4>Drawer Structure HTML</h4>
                <h4>https://r12a.github.io/app-conversion/</h4>
                    &lt;Drawer
                      visible={true}
                      className=&quot;drawer-wrapper&quot;
                    &gt;
                    &lt;/Drawer&gt;
                    &lt;div className=&quot;card-head&quot;&gt;&lt;h4&gt;Sidebar Header&lt;/h4&gt;&lt;/div&gt;
                    &lt;div className=&quot;card-row&quot;&gt;
                      &lt;div className=&quot;card-full&quot;&gt;
                        &lt;div className=&quot;form-group&quot;&gt;
                          &lt;div className=&quot;fitem&quot;&gt;
                            &lt;label htmlFor=&quot;&quot;&gt;Customer Status&lt;/label&gt;
                            &lt;div className=&quot;fitem-check&quot;&gt;
                              &lt;input type=&quot;checkbox&quot; className=&quot;fitem-ck-input&quot; id=&quot;active&quot;/&gt;
                              &lt;label htmlFor=&quot;active&quot; className=&quot;fitem-ck-txt&quot;&gt;Active&lt;/label&gt;
                            &lt;/div&gt;
                            &lt;div className=&quot;fitem-check&quot;&gt;
                              &lt;input type=&quot;checkbox&quot; className=&quot;fitem-ck-input&quot; id=&quot;in_active&quot;/&gt;
                              &lt;label htmlFor=&quot;in_active&quot; className=&quot;fitem-ck-txt&quot;&gt;InActive&lt;/label&gt;
                            &lt;/div&gt;
                          &lt;/div&gt;
                        &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div className=&quot;footer&quot;&gt;
                      &lt;button className=&quot;btn btn-primary&quot;&gt;Cancel&lt;/button&gt;
                      &lt;button className=&quot;btn btn-warning&quot;&gt;Filter Customer&lt;/button&gt;
                    &lt;/div&gt;                 
              </div>
            </div>
          </div>
          <Table columns={columns} dataSource={data} onChange={this.onChange} />
          
          {/* Account information starts here */}
          <div className="block-row customer-portal">
            <div className="container">
              <div className="cp-row">
                <div className="card">
                  <div className="card-title flex ai-center">
                    <h5>Account Info</h5>
                    <span className="link">Edit</span>
                  </div>
                  <div className="card-body">
                    <div className="flex">
                      <b className="flex-1">Primary User:</b>
                      <span className="flex-1">Michael Woods</span>
                    </div>
                    <div className="flex">
                      <b className="flex-1">Role:</b>
                      <span className="flex-1">Community Manager</span>
                    </div>
                    <p className="mt-10 mb-0">Authorized Users: 	Sarah Woods, Rebecca Woods</p>
                    <span className="clink">Add Authorized Users</span>
                    <div className="flex mt-20">
                      <b className="flex-1">Management Company:</b>
                      <span className="flex-1">Highwoods Properties</span>
                    </div>
                    <div className="flex">
                      <b className="flex-1">Community Name:</b>
                      <span className="flex-1">Highwoods Park</span>
                    </div>
                    <div className="inline-check-list gcheck sm-checks mt-20">
                      <b className="mb-10 d-block">Email Address:</b>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox3" name="checkboxs" />
                        <label htmlFor="checkbox3" className="fitem-ck-txt">michael@highwoodsproperties.com (Primary)  </label>
                      </div>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox4" name="checkboxs" />
                        <label htmlFor="checkbox4" className="fitem-ck-txt">michael@corporate.com</label>
                      </div>
                    </div>
                    <div className="inline-check-list gcheck sm-checks">
                      <b className="mb-10 d-block">Primary Phone:</b>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox2" name="checkboxs" />
                        <label htmlFor="checkbox2" className="fitem-ck-txt">+1-804-555-1234 (Primary)</label>
                      </div>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox5" name="checkboxs" />
                        <label htmlFor="checkbox5" className="fitem-ck-txt">+1-773-231-3413</label>
                      </div>
                    </div>
                    <span className="clink">Update Contact Details</span>
                  </div>
                </div>
                <div className="card">
                  <div className="card-title flex ai-center">
                    <h5>Community Info</h5>
                    <span className="link">Edit</span>
                  </div>
                  <div className="card-body">
                    <div className="flex mb-10">
                      <b>House Types:</b>
                      <span>Detached Homes</span>
                    </div>
                    <div className="flex mb-10">
                      <b>Number of Homes:</b>
                      <span>20-30</span>
                    </div>
                    <b className="mb-10 d-block">Community Boundary Map:</b>
                    <div className="flex">
                      <p className="fname">HWP.BoundaryMap.pdf</p>
                      <span className="clink">Add Authorized Users</span>
                    </div>
                    <div className="mt-20">
                      <b>Sample Address in the Community:</b>
                      <p>North Shore Commons, 1234 Lake Brook Drive, Richmond, Virginia, 23060</p>
                    </div> 
                    <span className="clink">Update Contact Details</span>                   
                  </div>
                </div>
                <div className="card">
                  <div className="card-title flex ai-center">
                    <h5>Account Info</h5>
                    <span className="link">Edit</span>
                  </div>
                  <div className="card-body">
                    <div className="flex">
                      <b>Primary User:</b>
                      <span>Michael Woods</span>
                    </div>
                    <div className="flex">
                      <b>Role:</b>
                      <span>Community Manager</span>
                    </div>
                    <p>Authorized Users: 	Sarah Woods, Rebecca Woods</p>
                    <span className="clink">Add Authorized Users</span>
                    <div className="flex">
                      <b>Management Company:</b>
                      <span>Highwoods Properties</span>
                    </div>
                    <div className="flex">
                      <b>Community Name:</b>
                      <span>Highwoods Park</span>
                    </div>
                    <div className="inline-check-list gcheck sm-checks">
                      <b>Email Address:</b>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox3" name="checkboxs" />
                        <label htmlFor="checkbox3" className="fitem-ck-txt">michael@highwoodsproperties.com (Primary)  </label>
                      </div>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox4" name="checkboxs" />
                        <label htmlFor="checkbox4" className="fitem-ck-txt">michael@corporate.com</label>
                      </div>
                    </div>
                    <div className="inline-check-list gcheck sm-checks">
                      <b>Primary Phone:</b>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox2" name="checkboxs" />
                        <label htmlFor="checkbox2" className="fitem-ck-txt">+1-804-555-1234 (Primary)</label>
                      </div>
                      <div className="fitem-check">
                        <input type="checkbox" className="fitem-ck-input" id="checkbox5" name="checkboxs" />
                        <label htmlFor="checkbox5" className="fitem-ck-txt">+1-773-231-3413</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Account information ends here */}


          {/* Invoice starts here */}
          <h1>Invoice</h1>
          <div className="res-body">
            <div className="block-row p-0">
              <div className="invoice-container">
                <h4>#AS-63166-23</h4>
                <div className="flex flex-service">
                  <div className="flex-1">              
                    <div className="bill-add">
                      <b>Bill to:</b>
                      <p>Tom Bellamy, <br/>701 Valley Dr, <br/>Saint Louis, <br/>MO 63137</p>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="form-group">
                      <div className="half-fitem fitem">
                        <div className="half-fitem fitem">
                          <label><b>Invoice Date</b></label>
                          <Select>
                            <option value="jack">Jack</option>
                            <option value="lucy">Lucy</option>
                            <option value="disabled" disabled>
                              Disabled
                            </option>
                            <option value="Yiminghe">yiminghe</option>
                          </Select>
                        </div>
                        <div className="half-fitem fitem">
                          <label><b>Invoice Date</b></label>
                          <Select>
                            <option value="jack">Jack</option>
                            <option value="lucy">Lucy</option>
                            <option value="disabled" disabled>
                              Disabled
                            </option>
                            <option value="Yiminghe">yiminghe</option>
                          </Select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 
                <div className="div-table">
                  <div className="divhead">
                    <div className="dcell sno">Service #</div>
                    <div className="dcell sdate">Date</div>
                    <div className="dcell stype">Type</div>
                    <div className="dcell sdesc">Description</div>              
                    <div className="dcell stax">Tax</div>              
                  </div>
                  <div className="divbody">
                    <div className="divrow">
                      <div className="dcell sno">WO-10291</div>
                      <div className="dcell sdate">05/15/2020</div>
                      <div className="dcell stype">Product</div>
                      <div className="dcell sdesc">Remove waste from property (weekly)</div>
                      <div className="dcell stax">
                        <div className="flex ai-center">
                          <div className="sprice">$25.00</div>
                          <div className="inline-check-list sm-checks">
                            <div className="fitem-check">
                              <input type="checkbox" className="fitem-ck-input" id="checkbox" name="checkboxs" />
                              <label htmlFor="checkbox" className="fitem-ck-txt"></label>
                            </div>
                            <input type="text" className="form-control" />
                          </div>
                        </div>
                        <i className="las la-trash-alt"></i>
                      </div>               
                    </div>
                    <div className="divrow">               
                      <div className="dcell sdate">05/15/2020</div>
                      <div className="dcell stype">Product</div>
                      <div className="dcell sdesc">Remove waste from property (weekly)</div>                
                      <div className="dcell stax">
                        <div className="flex ai-center">
                          <div className="sprice">$25.00</div>
                          <div className="inline-check-list sm-checks">
                            <div className="fitem-check">
                              <input type="checkbox" className="fitem-ck-input" id="checkbox" name="checkboxs" />
                              <label htmlFor="checkbox" className="fitem-ck-txt"></label>
                            </div>
                            <input type="text" className="form-control" />
                          </div>
                        </div>
                        <i className="las la-trash-alt"></i>
                      </div>                
                    </div>
                    <div className="divrow dfoot">
                      <div className="dcell">
                        <div className="btn-group">
                          <button className="btn disabled">Add Another Line</button>
                          <button className="btn disabled">Clear All</button>
                        </div>
                        <div className="form-group">
                          <div className="fitem">
                            <textarea className="form-control" placeholder="Add a message to your invoice"></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="dcell flex ai-start flex-end">
                        <div className="price-block">
                          <span>Total</span>
                          <span>Sales Tax</span>                  
                          <span>Amount Received </span>
                          <span>Balance Due</span>
                        </div>
                        <div className="pricing">                   
                          <span>$110.00</span>
                          <span>$2.13</span>
                          <span>$0.00</span>
                          <span>$112.13</span>                                        
                        </div>                  
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sticky-btn-grp">
                  <div className="flex ai-center">
                    <div className="flex-1 text-left links">
                      <span>Delete</span>
                      <span>Void</span>
                    </div>
                    <div className="flex-1">
                      <button className="btn disabled">Save</button>
                      <button className="btn btn-warning">Approve & Send Invoice</button>
                    </div>
                  </div>
                </div>    
              </div> 
                    
            </div>
          </div>
          {/* Invoice ends here */}
            
        </div>
        
      </div>    
    );
  }
}

export default Typo;
